import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as listReducer, REDUCER_NAME as LIST_REDUCER_NAME } from './list'

const reducer = combineReducers({
    [LIST_REDUCER_NAME]: listReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/logistic/state/index.js